import api from "./client"
import type { Client } from "../types"

export async function getClients(): Promise<Client[]> {
  const { data } = await api.get<Client[]>("/clients")
  return data
}

export async function createClient(params: {
  name: string
  email: string
  password: string
  client_type: string
}): Promise<Client> {
  const { data } = await api.post<{ user: Client }>("/users/sign_up", {
    user: { ...params, role: "member" },
  }, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  })
  return data.user
}

export async function updateClient(
  id: number,
  params: { name?: string; email?: string; client_type?: string }
): Promise<Client> {
  const { data } = await api.patch<Client>(`/clients/${id}`, { user: params })
  return data
}

export async function deleteClient(id: number): Promise<void> {
  await api.delete(`/clients/${id}`)
}

export async function createTrainer(params: {
  name: string
  email: string
  password: string
}): Promise<Client> {
  const { data } = await api.post<{ user: Client }>("/users/sign_up", {
    user: { ...params, role: "trainer" },
  }, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  })
  return data.user
}
